// Using a mock weather service since we don't have access to real API keys
// In a real application, you would use OpenWeatherMap API or similar service

const mockWeatherData = {
  Manila: {
    weather: [{ main: 'Clear', description: 'clear sky' }],
    main: {
      temp: 32,
      feels_like: 36,
      humidity: 65,
      pressure: 1013
    },
    wind: { speed: 3.5 },
    visibility: 10000,
    sys: {
      sunrise: Math.floor(Date.now() / 1000) - 3600,
      sunset: Math.floor(Date.now() / 1000) + 3600
    }
  },
  'Quezon City': {
    weather: [{ main: 'Clouds', description: 'partly cloudy' }],
    main: {
      temp: 30,
      feels_like: 34,
      humidity: 70,
      pressure: 1012
    },
    wind: { speed: 2.8 },
    visibility: 8000,
    sys: {
      sunrise: Math.floor(Date.now() / 1000) - 3600,
      sunset: Math.floor(Date.now() / 1000) + 3600
    }
  },
  'Cebu City': {
    weather: [{ main: 'Rain', description: 'light rain' }],
    main: {
      temp: 28,
      feels_like: 31,
      humidity: 85,
      pressure: 1010
    },
    wind: { speed: 4.2 },
    visibility: 5000,
    sys: {
      sunrise: Math.floor(Date.now() / 1000) - 3600,
      sunset: Math.floor(Date.now() / 1000) + 3600
    }
  },
  'Davao City': {
    weather: [{ main: 'Thunderstorm', description: 'thunderstorm with rain' }],
    main: {
      temp: 26,
      feels_like: 29,
      humidity: 90,
      pressure: 1008
    },
    wind: { speed: 5.5 },
    visibility: 3000,
    sys: {
      sunrise: Math.floor(Date.now() / 1000) - 3600,
      sunset: Math.floor(Date.now() / 1000) + 3600
    }
  },
  Baguio: {
    weather: [{ main: 'Mist', description: 'mist' }],
    main: {
      temp: 18,
      feels_like: 20,
      humidity: 95,
      pressure: 1015
    },
    wind: { speed: 1.5 },
    visibility: 2000,
    sys: {
      sunrise: Math.floor(Date.now() / 1000) - 3600,
      sunset: Math.floor(Date.now() / 1000) + 3600
    }
  }
};

const generateRandomWeatherData = (city) => {
  const conditions = ['Clear', 'Clouds', 'Rain', 'Thunderstorm', 'Mist'];
  const descriptions = {
    Clear: 'clear sky',
    Clouds: 'partly cloudy',
    Rain: 'light rain',
    Thunderstorm: 'thunderstorm with rain',
    Mist: 'mist'
  };
  
  const condition = conditions[Math.floor(Math.random() * conditions.length)];
  const baseTemp = 25 + Math.random() * 10; // 25-35°C typical for Philippines
  
  return {
    weather: [{ main: condition, description: descriptions[condition] }],
    main: {
      temp: Math.round(baseTemp),
      feels_like: Math.round(baseTemp + Math.random() * 5),
      humidity: Math.round(60 + Math.random() * 35), // 60-95%
      pressure: Math.round(1008 + Math.random() * 10) // 1008-1018 hPa
    },
    wind: { speed: Math.round((Math.random() * 6 + 1) * 10) / 10 }, // 1-7 m/s
    visibility: Math.round(Math.random() * 8000 + 2000), // 2-10 km
    sys: {
      sunrise: Math.floor(Date.now() / 1000) - 3600,
      sunset: Math.floor(Date.now() / 1000) + 3600
    }
  };
};

export const getWeatherData = async (city) => {
  // Simulate API delay
  await new Promise(resolve => setTimeout(resolve, 1000));
  
  // Return mock data for specific cities or generate random data
  if (mockWeatherData[city]) {
    return mockWeatherData[city];
  }
  
  return generateRandomWeatherData(city);
};

// In a real application, you would use something like this:
/*
const API_KEY = 'your-openweathermap-api-key';
const BASE_URL = 'https://api.openweathermap.org/data/2.5';

export const getWeatherData = async (city) => {
  try {
    const response = await fetch(
      `${BASE_URL}/weather?q=${city},PH&appid=${API_KEY}&units=metric`
    );
    
    if (!response.ok) {
      throw new Error('Weather data not found');
    }
    
    const data = await response.json();
    return data;
  } catch (error) {
    throw new Error('Failed to fetch weather data');
  }
};
*/